import { useState } from 'react';
import { Link } from 'react-router-dom';

const WA_HREF = 'https://wa.me/905325416344?text=Merhaba%2C%20bilgi%20almak%20istiyorum.';
const PHONE_HREF = 'tel:+905325416344';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    try {
      const body = new URLSearchParams();
      body.append('email', email);
      await fetch('https://readdy.ai/api/form/d7afl0n6e3lk97049rgg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      setSubmitted(true);
    }
  };

  return (
    <footer className="bg-slate-800 text-white pt-16 pb-6">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-orange-500">
                <i className="ri-computer-line text-white text-lg"></i>
              </div>
              <div>
                <span className="font-extrabold text-base leading-none block text-white">Teknik Servis</span>
                <span className="text-xs leading-none text-orange-400">Bilgisayar &amp; Yazılım</span>
              </div>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-5">
              Profesyonel teknik servis ve 2. el bilgisayar satışında güvenilir adresiniz. Aydınlıkevler / Ankara.
            </p>
            <div className="flex gap-2">
              <a
                href={WA_HREF}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-xs font-bold transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i> WhatsApp
              </a>
              <a
                href={PHONE_HREF}
                className="flex items-center gap-2 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg text-xs font-bold transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-phone-line"></i> Ara
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5">Hızlı Linkler</h4>
            <ul className="space-y-3">
              {[
                { label: 'Ana Sayfa', path: '/' },
                { label: 'İkinci El Satış', path: '/ikinci-el' },
                { label: 'Yazılım', path: '/yazilim' },
                { label: 'İletişim', path: '/iletisim' },
              ].map(link => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-slate-400 hover:text-orange-400 text-sm transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-orange-500"></i>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5">Hizmetlerimiz</h4>
            <ul className="space-y-3">
              {[
                'Laptop Tamiri',
                'Format ve Kurulum',
                'Kamera Sistemleri',
                'POS Cihaz Servisi',
                'Güvenlik Sistemleri',
                'Donanım Yükseltme',
              ].map(service => (
                <li key={service} className="text-slate-400 text-sm flex items-center gap-2">
                  <i className="ri-tools-line text-orange-500 text-xs"></i>
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Newsletter */}
          <div>
            <h4 className="text-white font-semibold text-base mb-5">İletişim</h4>
            <ul className="space-y-3 mb-6">
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <i className="ri-phone-line text-orange-500 mt-0.5 flex-shrink-0"></i>
                <a href={PHONE_HREF} className="hover:text-orange-400 transition-colors cursor-pointer">0532 541 63 44</a>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <i className="ri-whatsapp-line text-green-500 mt-0.5 flex-shrink-0"></i>
                <a href={WA_HREF} target="_blank" rel="noopener noreferrer" className="hover:text-green-400 transition-colors cursor-pointer">WhatsApp</a>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <i className="ri-mail-line text-orange-500 mt-0.5 flex-shrink-0"></i>
                <a href="mailto:goldsbilisim06@gmail.com" className="hover:text-orange-400 transition-colors cursor-pointer">goldsbilisim06@gmail.com</a>
              </li>
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <i className="ri-map-pin-line text-orange-500 mt-0.5 flex-shrink-0"></i>
                <span>Çevreli Cad. Çaba Sok. No:1/D10, Aydınlıkevler / ANKARA</span>
              </li>
            </ul>
            <h5 className="text-white font-medium text-sm mb-3">Bülten Aboneliği</h5>
            {submitted ? (
              <p className="text-green-400 text-sm">Abone oldunuz, teşekkürler!</p>
            ) : (
              <form onSubmit={handleNewsletter} data-readdy-form className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="E-posta adresiniz"
                  className="flex-1 bg-slate-700 border border-slate-600 rounded-lg px-3 py-2 text-sm text-white placeholder-slate-500 focus:outline-none focus:border-orange-500"
                  required
                />
                <button
                  type="submit"
                  className="bg-orange-500 hover:bg-orange-600 text-white px-3 py-2 rounded-lg transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-send-plane-line"></i>
                </button>
              </form>
            )}
          </div>
        </div>

        <div className="border-t border-slate-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-sm">© 2024 Teknik Servis. Tüm hakları saklıdır.</p>
          <div className="flex gap-4">
            <Link to="/gizlilik" className="text-slate-500 hover:text-slate-300 text-sm cursor-pointer">Gizlilik Politikası</Link>
            <Link to="/kullanim-sartlari" className="text-slate-500 hover:text-slate-300 text-sm cursor-pointer">Kullanım Şartları</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
